import he from 'he'
import { mapState, mapActions } from 'vuex'
// import ScrollHeader from '@/lib/scroll-header'
import mediaActions from './media-actions'

import Comments from '@/components/comments'
import DownArrow from '@/components/down-arrow'

export const User = {
  computed: {
    ...mapState([ 'user' ])
  }
}

export const Site = {
  computed: {
    ...mapState({
      siteTitle: state => state.site.title || '',
      siteDescription: state => state.site.description || '',
      siteLogo: state => state.site.logo || '',
    })
  }
}

export const Post = {
  mixins: [ User, Site ],
  components: { DownArrow, Comments },
  props: [ 'post' ],
  data() {
    return {
      loading: true,
      storedPost: {},
      show: false
    }
  },
  mounted() {
    this.storedPost = Object.assign( {}, this.$store.state.post )
    document.title = he.decode( this.title + ' | ' + this.siteTitle )
    // this.$nextTick(() => {
    //   ScrollHeader.init( '#masthead', '#app>.page>.featured-outer' )
    // })
  },
  // updated() {
  //   this.$nextTick(() => {
  //     ScrollHeader.init( '#masthead', '#app>.page>.featured-outer' )
  //   })
  // },
  methods: {
    showImg() {
      this.show = true
    }
  },
  computed: {
    postData() {
      return this.post || this.storedPost
    },
    title() {
      return ( this.postData.title && this.postData.title.rendered ) || ''
    },
    img() {
      return this.postData.background_image || ''
    },
    content() {
      const user = this.user
      if ( this.postData.member_content &&
           ( user.as ? user.as.subscriber : user.membership )) {
        return this.postData.member_content
      }
      return ( this.postData.content && this.postData.content.rendered ) || ''
    },
  },
}

export const Page = {
  mixins: [ Post ],
  methods: {
    ...mapActions([ 'startLoading', 'stopLoading' ]),
    pageLoaded() {
      this.showImg()
      this.stopLoading( 'page' )
    }
  }
}

export const PostList = {
  mixins: [ Page ],
  props: [ 'path' ],
  methods: {
    postTitle( post ) {
      return ( post.title && post.title.rendered ) || ''
    },
    postContent( post ) {
      const user = this.user
      if ( post.member_content &&
           ( user.as ? user.as.subscriber : user.membership )) {
        return post.member_content
      }
      return ( post.content && post.content.rendered ) || ''
    }
  },
  computed: {
    postData() {
      return this.post || this.storedPost
    },
    posts() {
      return this.postData.posts || []
    },
  },
}

export const Clickable = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFocused: false,
      isActive: false,
    }
  },
  computed: {
    listeners() {
      const listeners = {
        ...this.$listeners,
        focus: () => {
          this.isFocused = true
          this.$emit( 'focus' )
        },
        blur: () => {
          this.isFocused = false
          this.$emit( 'blur' )
        },
      }
      const click = this.$listeners.click
      if ( click ) {
        listeners.click = $event => {
          if ( this.disabled ) {
            this.isActive = true
            this.$nextTick(() => { this.isActive = false })
            if ( listeners[ 'click:disabled' ]) {
              listeners[ 'click:disabled' ]( $event )
            } else {
              this.$emit( 'click:disebled', $event )
            }
          } else {
            click( $event )
          }
        }
      } else if ( this.disabled ) {
        listeners.click = $event => {
          $event.stopPropagation()
          $event.preventDefault()
          return false
        }
      }
      return listeners
    },
    classes() {
      return {
        focus: this.isFocused,
        active: this.isActive,
        disabled: this.disabled
      }
    }
  }
}

export {
  mediaActions
}
